export const validation = {
  required: "必須項目です",
  number: "数値を入力してください",
  numberPositive: "正の数値を入力してください",
  numberInteger: "整数を入力してください",
};
